<template>
  <div
    style="
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index:999;    
      "
  >
    <div
      v-if="isHovered"
      style="
        position: absolute;
        bottom: 3%;
        transform: translateX(-55%) translateY(-1%);
        background-color:lightgray;
        color: black;
        border-radius: 0.25rem;
        text-align: center;
        width: max-content;
        min-width: 15rem;
        min-height: 2rem;
        height: max-content;
        padding: 0.30rem;
        font-size: 10px;
        white-space: nowrap;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
        margin-top:1%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: verdana;
        z-index:5;
        top:1%
      "
      :class="{ 'show-above ': showAbove}"
    >
      <div  style="display: flex; gap: 0.5rem">
        <div>{{ createdAtLabel }}:</div>
        <div>{{ modify_date_format(createdAt) }}</div>
      </div>
      <div style="display: flex; gap: 0.5rem ">
        <div>{{ createdByLabel }}:</div>
        <div>{{ createdBy }}</div>
      </div>
      <div style="display: flex; gap: 0.5rem">
        <div>{{ updatedAtLabel }}:</div>
        <div>{{ modify_date_format(updatedAt) }}</div>
      </div>
      <div style="display: flex; gap: 0.5rem ">
        <div>{{ updatedByLabel }}:</div>
        <div>{{ updatedBy }}</div>
      </div>
      <slot name="additional-metadata"></slot>
    </div>
  </div>
</template>

<script>
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import moment from "moment";

export default {
  name: "HoverMetadataComponent",
  components: {
    FeatherIcon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    idField: {
      type: String,
      required: true,
    },
    createdAt: {
      type: String,
      default: null,
    },
    createdBy: {
      type: String,
      default: null,
    },
    updatedAt: {
      type: String,
      default: null,
    },
    updatedBy: {
      type: String,
      default: null,
    },
    createdAtLabel: {
      type: String,
      default: "CREATED AT",
    },
    createdByLabel: {
      type: String,
      default: "CREATED BY",
    },
    updatedAtLabel: {
      type: String,
      default: "UPDATED AT",
    },
    updatedByLabel: {
      type: String,
      default: "UPDATED BY",
    },
    icon: {
      type: String,
      default: "InfoIcon",
    },
    iconSize: {
      type: [String, Number],
      default: "23",
    },
    isHovered: Boolean,
    showAbove: Boolean,
  },
  data() {
    return {
      hoveredId: null, 
    };
  },
  methods: {
    handleHover(id) {
      this.hoveredId = id;
      this.isHovered = true ;
      this.$emit("hover", id);
    },
    handleRelease(id) {
      this.hoveredId = null;
      this.isHovered = false;
      this.$emit("release", id);
    },
    getValue(field) {
      if (Array.isArray(field)) {
        return field.find((key) => this.item[key] !== undefined)
          ? this.item[field.find((key) => this.item[key] !== undefined)]
          : null;
      }
      // if(field === 'createdAt' || field === 'updatedAt'){
      //    return this.item[field] = moment(this.item[field]).format('dd-mm-yyyy') ;
      // }
      return this.item[field] || null;
    },
    modify_date_format(date){
      if(date === null || date === undefined || date === ""){
        return null;
      }
      if(date.includes("0000-00-00")){
        return null;
      }
      if(date.includes("T")){
        return date.split("T")[0];;
      }else{
        return date;;
      }
    }
  },
  mounted(){
     console.log('coming-here') ;
   }
};
</script>

<style scoped>
.hover-metadata-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.info-icon {
  cursor: pointer;
}

.metadata-tooltip {
  position: absolute;
  bottom: 35%;
  transform: translateX(-50%);
  background-color: rgb(31, 48, 122);
  color: white;
  border-radius: 0.25rem;
  text-align: center;
  width: max-content;
  min-width: 15rem;
  min-height: 5rem;
  height: max-content;
  padding: 1rem;
  font-size: 10px;
  white-space: nowrap;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  margin-top: 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: verdana;
  z-index: 100;
}

.show-above {
  transform: translateX(-55%) translateY(-100%) !important;
}

.metadata-row {
  display: flex;
  gap: 0.5rem;
}
</style>
